import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
var getUserCulture = function () {
    var optionState = getRegionalOptions();
    var SessionSettings = getUserConfiguration().SessionSettings;
    return optionState.selectedLocale || SessionSettings.UserCulture;
};
export default getUserCulture;
//# sourceMappingURL=getUserCulture.js.map